import axios from "axios"
import { sessionData } from '../store/local';
// 创建一个axios实例
const http = axios.create({
        //通用请求地址前缀
        baseURL: process.env.NODE_ENV === 'production' ? 'https://drivers.momen.world/api' : '/api',
        timeout: '10000', //超时时间
    })
    // 添加请求拦截器
http.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    let token = sessionData.get('token')
    config.headers.Authorization = 'Bearer ' + token;
    if (token) {
        // XXX 在此处把token放到header头里
        config.headers['token'] = token;
        console.log(config);
    }
    console.log('---------------////////////////------*************');
    return config;
}, function(error) {
    console.log('----------**************-----------*************');
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function(response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    console.log('---------------------*************', response);
    return response;
}, function(error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    console.log('---------------------', error);
    return Promise.reject(error);
});
export default http